import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF } from '@fortawesome/free-brands-svg-icons'
import Button from '@material-ui/core/Button'

const useStyles = makeStyles((theme) => ({
    facebookButton: {
        backgroundColor: '#4267b2',
        color: 'white',
        textTransform: 'none',
        height: '45px',
        '&:hover': {
            backgroundColor: '#4267b275',
        },
    },
}))

const FacebookLoginButton = (props) => {
    const { facebookLoginUrl, classNameOverride } = props
    const classes = useStyles()

    return (
        <Button
            data-testid="facebook-login-button"
            className={`${classes.facebookButton} ${classNameOverride}`}
            fullWidth
            size="large"
            href={facebookLoginUrl}
            rel="nofollow"
            startIcon={<FontAwesomeIcon icon={faFacebookF} color={'white'} />}
        >
            Log in with Facebook
        </Button>
    )
}

export default FacebookLoginButton

FacebookLoginButton.propTypes = {
    facebookLoginUrl: PropTypes.string.isRequired,
    classNameOverride: PropTypes.string,
}
